import React from 'react';

const SettingsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true
			}
		}
	},
	routes: [
		{
			path: '/admin/settings',
			exact: true,
			component: React.lazy(() => import('./SettingsPage'))
		}
	]
};

export default SettingsPageConfig;
